import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { User } from '../../services/types';
import { resetReduxState } from '../actions';

interface UsersState {
  users: User[];
  totalCount: number;
  lastFetchedUserType: string | null;
  currentPage: number;
  pageSize: number;
}

const initialState: UsersState = {
  users: [],
  totalCount: 0,
  lastFetchedUserType: null,
  currentPage: 1,
  pageSize: 10,
};


const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
   

    setUsers: (
        state,
        action: PayloadAction<{
        data: User[];
        totalCount: number;
        lastFetchedUserType: string | null;
        }>
    ) => {
        state.users = action.payload.data;
        state.totalCount = action.payload.totalCount;
        state.lastFetchedUserType = action.payload.lastFetchedUserType
    },

    // Update pagination
    setCurrentPage: (state, action: PayloadAction<number>) => {
        state.currentPage = action.payload;
    },

    setPageSize: (state, action: PayloadAction<number>) => {
        state.pageSize = action.payload;
        state.currentPage = 1; // Reset to first page when changing page size
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetReduxState, (state) => {
      // Reset to initial state
      state.users = [];
    });
  },
});

export const { setUsers, setCurrentPage, setPageSize } = usersSlice.actions;
export default usersSlice.reducer; 